import styled from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import color from '@deprecated-ui/_style/color';
import device from '@deprecated-ui/_style/device';
import { Page, PageTheme } from 'config/theme';

interface IProps {
  theme?: PageTheme;
}

const Footer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;

  a {
    color: ${color.highempahis};
    text-decoration: none;
    margin: 8px 4px;
  }

  ${({ theme }: IProps) => {
    if (theme.page === Page.privacyDark) {
      return ` 
        color: ${theme.textPrimary};
        background: ${theme.backgroundSecondary};
        
        div {
          background: ${theme.backgroundSecondary};
        }

        a {
          color: ${theme.textPrimary};
        }
      `;
    }
    return '';
  }}
`;

const Wrapper = styled.div`
  background-color: ${color.whiteSmoke};
  padding: 10px;
  min-height: 100vh;

  ${({ theme }: IProps) => {
    if (theme.page === Page.privacyDark) {
      return ` 
      background: ${theme.backgroundSecondary};
      
      div {
        background: ${theme.backgroundSecondary};
      }

      h1, h2, h3, ol, li, p {
        color: ${theme.textPrimary};
      }

      .ant-card-bordered {
        border: 1px solid #333333;
      }
    `;
    }
    return '';
  }}

  @media ${device.tablet} {
    padding: 20px 0;
  }
`;

const Header = styled(Flex)`
  justify-content: center;

  @media ${device.tablet} {
    justify-content: space-between;
  }
`;

export { Footer, Wrapper, Header };
